<div class="border-bottom container-fluid mw-100">
  @if (equipment()) {
    <div class="row px-2 py-2 gx-4 main-row">
      <div class="col-auto d-none d-md-flex align-items-center" [style.width.px]="selectionWidth">
        @if (selectable()) {
          <app-selection-checkbox
            [ngModel]="selected() ? checkboxSelectionState.selected : checkboxSelectionState.unselected"
            (ngModelChange)="selectionToggled.emit()"></app-selection-checkbox>
        }
      </div>
      <div class="col-auto px-0 d-flex align-items-center">
        <button type="button" class="btn p-2 rounded-circle action-btn-lg" (click)="collapsed.set(!collapsed())"
                [ngClass]="collapsible() ? '' : 'invisible'" data-bs-toggle="collapse"
                aria-expanded="false" style="visibility: hidden">
          <span class="h1 m-0 align-top text-primary">
            <i class="fa-light fa-fw" [ngClass]="collapsed() ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
          </span>
        </button>
      </div>
      <div class="col col-xl-2 col-xxl-1 col-vlg-auto d-flex align-items-center" [style.min-width.px]="210">
        <span class="sub-text me-2">
          <i class="fa fa-fw fa-light fa-xl" [ngClass]="utils.getEquipmentIconCls(equipment().equipment.sizeType, equipment().equipment.empty)"></i>
        </span>
        <div class="h-100 w-0 flex-grow-1 d-flex flex-column align-items-stretch justify-content-center">
          <span class="d-inline-block text-truncate mw-100 cursor-pointer underline-tertiary link-underline-tertiary link-primary text-body" (click)="editEquipment()">
            <app-highlight [term]="term()" [result]="equipment().equipment?.equipmentNumber" (textHighlighted)="onHighlightMatch()"></app-highlight>
          </span>
        </div>
      </div>
      @if (equipment().houseConsignments.length) {
        <div class="col-auto d-none d-xxl-flex flex-row" [style.min-width.px]="200">
          <div class="d-inline-flex me-1 align-items-center">
            <i class="fa fa-kit fa-fw fa-light fa-lg fa-pb-file-line"></i>
          </div>
          <div class="d-flex flex-column align-items-stretch justify-content-center">
            <app-consignment-house-column [houseConsignments]="equipment().houseConsignments"
                                          [consignmentProcessId]="consignmentProcessId()"
                                          [term]="term()"></app-consignment-house-column>
          </div>
        </div>
      }
      <div class="col d-none d-sm-flex flex-row align-items-center justify-content-stretch w-0">
        @if (!equipment().equipment.empty) {
          @if (goods()?.length) {
            <span class="sub-text me-2">
              <i class="fa fa-fw fa-light fa-xl fa-box-open"></i>
            </span>
          }
          <app-consignment-goods-column class="mw-100" [goods]="goods()" [term]="term()"
                                        [ellipsisCharacterCount]="40"></app-consignment-goods-column>
        }
      </div>
      @if (terminalStatuses()?.length) {
        <div class="col-auto ms-auto">
          <div class="row gy-2 gx-3">
            <div class="col-auto d-flex flex-column status-column status-column-left">
              <div class="row g-0 gx-2">
                <div class="col-auto d-flex flex-column">
                  @if (terminalStatuses()?.length) {
                    <span (click)="terminalStatusIndicator.toggleElement()" class="d-none d-sm-inline-block text-start cursor-pointer hover-underline" [style.line-height.rem]="1.5"
                          [style.min-width.px]="80">
                      Terminal
                    </span>
                  }
                </div>
                <div class="col d-flex flex-column">
                  <app-status-indicator #terminalStatusIndicator
                                        class="col-auto" [ngClass]="terminalStatuses().length ? 'd-block' : 'd-none'"
                                        [messageStatuses]="terminalStatuses()" summarySize="vlg"></app-status-indicator>
                </div>
              </div>
            </div>
            <div class="col-auto d-flex flex-column status-column status-column-right">
              <div class="row g-0 gx-2">
                <div class="col-auto d-flex flex-column">
                  <!--                <span class="d-none d-sm-inline-block text-start cursor-pointer hover-underline" [style.line-height.rem]="1.5">-->
                  <!--                  Release Party-->
                  <!--                </span>-->
                </div>
                <div class="col d-flex flex-column">
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="col-auto ms-auto d-none d-md-flex flex-column align-items-stretch justify-content-center"
           [style.width.px]="120" [title]="totalWeight() | numberFormat">
        <span class="d-block text-truncate mw-100 text-end">{{ totalWeight() | numberFormat }} kg</span>
      </div>
      <div class="col-auto d-flex flex-row align-items-stretch justify-content-center dropdown px-2">
        <a class="d-none d-md-block btn rounded-circle p-2 text-primary h1 mb-0 action-btn-lg" type="button"
           (click)="editEquipment()">
          <i class="fa-light fa-chevron-right"></i>
        </a>
        <button class="btn rounded-circle p-2 text-primary h1 mb-0 action-btn-lg invisible" type="button"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fa-light fa-ellipsis-vertical"></i>
        </button>
        <div class="dropdown-menu position-fixed">
        </div>
      </div>
    </div>
  }
</div>
